import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCog,
    faHouseUser,
    faKey,
    faMoneyBillAlt,
    faSearchDollar,
    faTools,
    faUniversity,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";

import "./styles.css";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { IModuloInterface } from "../../Context/User";
import { ACESSOS } from "../../Routes/Acessos";

export default function Modulos(
    ID_MODULO: number | undefined,
    CUSTOM_ID?: string,
    CUSTOM_CLASS?: string
) {
    switch (ID_MODULO) {
        case ACESSOS.COBRANCA.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_cobranca_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Cobrança"
                >
                    <FontAwesomeIcon icon={faSearchDollar} />
                </span>
            );
        case ACESSOS.ATENDIMENTO.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_atendimento_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Atendimento ao Cliente"
                >
                    <FontAwesomeIcon icon={faUsers} />
                </span>
            );
        case ACESSOS.ASSISTENCIA.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_assistencia_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Assistência Técnica"
                >
                    <FontAwesomeIcon icon={faTools} />
                </span>
            );
        case ACESSOS.VENDAS.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_vendas_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Vendas"
                >
                    <FontAwesomeIcon icon={faMoneyBillAlt} />
                </span>
            );
        case ACESSOS.REPASSE.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_repasse_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Repasse"
                >
                    <FontAwesomeIcon icon={faUniversity} />
                </span>
            );
        case ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_chaves_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Entrega de Chaves"
                >
                    <FontAwesomeIcon icon={faKey} />
                </span>
            );
        case 7:
            return (
                <span
                    className={
                        "modulo_component modulo_posOc_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Pós Ocupacional"
                >
                    <FontAwesomeIcon icon={faHouseUser} />
                </span>
            );
        case ACESSOS.HELPDESK.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_helpDesk_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Atedimento Whatsapp"
                >
                    <FontAwesomeIcon icon={faWhatsapp} />
                </span>
            );
        case ACESSOS.AUTOMACAO.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component modulo_automacao_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Automação"
                >
                    <FontAwesomeIcon icon={faCog} />
                </span>
            );

        default:
            return <></>;
    }
}

interface IModulosLG {
    Modulo: IModuloInterface;
    CUSTOM_ID?: string;
    CUSTOM_CLASS?: string;
}

export function ModulosLG(props: IModulosLG) {
    const { Modulo, CUSTOM_CLASS, CUSTOM_ID } = props;

    switch (Modulo.ID_MODULO) {
        case ACESSOS.COBRANCA.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_cobranca_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Cobrança"
                >
                    <FontAwesomeIcon icon={faSearchDollar} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case ACESSOS.ATENDIMENTO.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_atendimento_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Atedimento Ao Cliente"
                >
                    <FontAwesomeIcon icon={faUsers} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case 1:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_assistencia_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Assistência Técnica"
                >
                    <FontAwesomeIcon icon={faTools} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case 4:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_vendas_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Vendas"
                >
                    <FontAwesomeIcon icon={faMoneyBillAlt} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case 5:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_repasse_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Repasse"
                >
                    <FontAwesomeIcon icon={faUniversity} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_chaves_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Entrega de Chaves"
                >
                    <FontAwesomeIcon icon={faKey} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case 7:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_posOc_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Pós Ocupacional"
                >
                    <FontAwesomeIcon icon={faHouseUser} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case ACESSOS.HELPDESK.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_helpDesk_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Atendimento Whatsapp"
                >
                    <FontAwesomeIcon icon={faWhatsapp} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        case ACESSOS.AUTOMACAO.ID_MODULO:
            return (
                <span
                    className={
                        "modulo_component_lg text-break text-center modulo_automacao_component " +
                        CUSTOM_CLASS
                    }
                    id={CUSTOM_ID}
                    title="Automação"
                >
                    <FontAwesomeIcon icon={faCog} />
                    <span className="ds_modulo_span">{Modulo.DS_MODULO}</span>
                </span>
            );
        default:
            return <></>;
    }
}
